import React, { useEffect } from "react";

import LiquidacionStep1 from '../../Resources/Images/Tutoriales/Liquidacion/Liquidacion-1.jpg';
import LiquidacionStep2 from '../../Resources/Images/Tutoriales/Liquidacion/Liquidacion-2.jpg';
import StepTutorial from './index-step';

function getSteps() {
    return ['Paso 1', 'Paso 2'];
}

function getStepContent(stepIndex) {
    switch (stepIndex) {
        case 0:
            return <StepTutorial image={LiquidacionStep1} text={['Hacer clic en “Ingresar” para ser redirigido al portal de ebroker para acceder a la información solicitada.']} />
        case 1:
            return <StepTutorial image={LiquidacionStep2} text={['Accede al portal de ebroker volviendo a ingresar tus credenciales']} />
        default:
            return '¡Tutorial completado!';
    }
}

export function Liquidacion({ activeStep, setSteps }) {
    const steps = getSteps();

    useEffect(() => {
        setSteps(steps);
    }, [setSteps, steps]);

    return (
        <>
            <h2>Liquidación</h2>
            <div className="d-flex justify-content-center mb-4">
                {steps.map((label, index) => (
                    <div
                        key={label}
                        className={`text-center mx-2 px-3 py-2 rounded ${index === activeStep ? 'bg-primary text-white' : 'bg-light text-secondary'}`}
                        style={{ minWidth: 80 }}
                    >
                        <div className="fw-bold">{label}</div>
                        <div className="small">Paso {index + 1}</div>
                    </div>
                ))}
            </div>

            <div>
                {getStepContent(activeStep)}
            </div>
        </>
    );
}
